<script setup lang="ts">
import type { NuxtError } from '#app';
import Information from '~/components/pages/homepage/information/Information.vue';
import PageNotFound from '~/components/general/pageNotFound/pageNotFound.vue';

defineProps({
    error: {
        type: Object as () => NuxtError,
        required: true,
    },
});
</script>

<template>
    <NuxtLayout name="error">
        <PageNotFound :error="error" />

        <Information />
    </NuxtLayout>
</template>

<style scoped lang="scss">
</style>
